"use strict";
/**
 * OpenSearch Index Template Structural Types
 *
 * Plain, AWS-SDK-FREE structural types that model a composable OpenSearch index
 * template body and the per-family build options used by each family's template
 * builder. shared-types is the pure, dependency-free contract package, so these
 * types intentionally carry NO `@aws-sdk` / `@opensearch-project` imports — they
 * are hand-modeled to match exactly the shape the reindex script's
 * `defaultPatternsTemplate` (and the other family templates) return.
 *
 * These types are the structural foundation for the canonical per-family template
 * builders (`buildPatternTemplate`, `buildUserTemplate`, …) added in later tasks.
 */
Object.defineProperty(exports, "__esModule", { value: true });
